const colors = [
  'rgba(253, 0, 1, 1)',
  'rgba(255, 191, 5, 1)',
  'rgba(255, 254, 2, 1)',
  'rgba(0, 174, 81, 1)',
  'rgba(4, 35, 51, 0.9)',
];

export const opcoes = {
  color: colors,
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow'
    }
  },
  legend: {
    data: [
      '1. Excesso',
      '2. Adequado',
      '3. Baixa Exposição a Ruptura',
      '4. Elevada Exposição a Ruptura',
      '5. Em Ruptura'
    ],
    itemHeight: 17,
    itemWidth: 17,
    icon: "rect",
    padding: [0, 0, 20, 0]
  },
  grid: {
    left: '10',
    right: '10',
    bottom: '10',
    top: '25',
    containLabel: true
  },
  xAxis: [{
    type: 'value',
    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    show: false,
    axisLine: {
      show: false
    }
  }],
  yAxis: [{
    type: 'value',
    max: 100
  }],
  series: [
    {
      name: 'Email',
      type: 'bar',
      stack: 'Ad',
      emphasis: {
        focus: 'series'
      },
      data: [120, 132, 101, 134, 90, 230, 210]
    },
    {
      name: 'Union Ads',
      type: 'bar',
      stack: 'Ad',
      emphasis: {
        focus: 'series'
      },
      data: [220, 182, 191, 234, 290, 330, 310]
    },
    {
      name: 'Video Ads',
      type: 'bar',
      stack: 'Ad',
      emphasis: {
        focus: 'series'
      },
      data: [150, 232, 201, 154, 190, 330, 410]
    }
  ]
};
